import { authedApiFetch } from 'utils/Api';

const salesforceAccountsService = {
	// Blank filter values are omitted so the API treats them as "All". Same
	// { data, totalCount } shape as getFundraisings for useInfiniteResource.
	getAccounts: async (page = 1, perPage = 25, filters = {}, sort = {}) => {
		const params = new URLSearchParams();
		params.set('page', page);
		params.set('per_page', perPage);

		Object.entries(filters).forEach(([key, value]) => {
			if (value !== '' && value != null) {
				params.set(`filters[${key}]`, value);
			}
		});

		if (sort?.sortBy) {
			params.set('sort_by', sort.sortBy);
			params.set('sort_dir', sort.sortDir === 'desc' ? 'desc' : 'asc');
		}

		const response = await authedApiFetch({
			endpoint: `/salesforce_accounts?${params.toString()}`,
			method: 'GET',
		});
		return {
			data: response?.accounts || [],
			totalCount: response?.total || 0,
			assignedToMe: response?.assigned_to_me ?? null,
		};
	},

	// Options for the All LPs filter dropdowns.
	getPicklistValues: async () => {
		return await authedApiFetch({
			endpoint: '/salesforce_accounts/picklist_values',
			method: 'GET',
		});
	},

	getAccount: async (accountId) => {
		return await authedApiFetch({
			endpoint: `/salesforce_accounts/${accountId}`,
			method: 'GET',
		});
	},

	getContacts: async (accountId, page, perPage) => {
		return await authedApiFetch({
			endpoint: `/salesforce_accounts/${accountId}/contacts?page=${page}&per_page=${perPage}`,
			method: 'GET',
		});
	},

	getTotalCommitments: async (accountId) => {
		return await authedApiFetch({
			endpoint: `/salesforce_accounts/${accountId}/total_commitments`,
			method: 'GET',
		});
	},

	getContributionsToDate: async (accountId) => {
		return await authedApiFetch({
			endpoint: `/salesforce_accounts/${accountId}/contributions_to_date`,
			method: 'GET',
		});
	},

	getActivePipeline: async (accountId) => {
		return await authedApiFetch({
			endpoint: `/salesforce_accounts/${accountId}/active_pipeline`,
			method: 'GET',
		});
	},

	getLastInteraction: async (accountId) => {
		return await authedApiFetch({
			endpoint: `/salesforce_accounts/${accountId}/last_interaction`,
			method: 'GET',
		});
	},

	getInteractions: async (accountId, page, perPage) => {
		return await authedApiFetch({
			endpoint: `/salesforce_accounts/${accountId}/interactions?page=${page}&per_page=${perPage}`,
			method: 'GET',
		});
	},

	getInteractionActivity: async (accountId) => {
		return await authedApiFetch({
			endpoint: `/salesforce_accounts/${accountId}/interaction_activity`,
			method: 'GET',
		});
	},

	getInvestorCommitments: async (accountId) => {
		return await authedApiFetch({
			endpoint: `/salesforce_accounts/${accountId}/investor_commitments`,
			method: 'GET',
		});
	},

	getInvestorCommitmentDetails: async (accountId, investorId) => {
		return await authedApiFetch({
			endpoint: `/salesforce_accounts/${accountId}/investor_commitments/${investorId}/details`,
			method: 'GET',
		});
	},

	// Same response shape as salesforceEntitiesService.getFundraisings so
	// useInfiniteResource consumers can treat the two identically.
	getFundraisings: async (accountId, page = 1, perPage = 25, filters = {}, sort = {}) => {
		const params = new URLSearchParams();
		params.set('page', page);
		params.set('per_page', perPage);

		Object.entries(filters).forEach(([key, value]) => {
			if (value !== '' && value != null) {
				params.set(`filters[${key}]`, value);
			}
		});

		if (sort?.sortBy) {
			params.set('sort_by', sort.sortBy);
			params.set('sort_dir', sort.sortDir === 'desc' ? 'desc' : 'asc');
		}

		const response = await authedApiFetch({
			endpoint: `/salesforce_accounts/${accountId}/salesforce_fundraisings?${params.toString()}`,
			method: 'GET',
		});
		return {
			data: response?.fundraisings || [],
			totalCount: response?.total || 0,
		};
	},

};

export default salesforceAccountsService;
